// Simple localStorage wrapper with JSON handling & safe fallbacks.
const PREFIX = 'bsi_'; // Barangay San Isidro prefix

export const storage = {
  get(key, fallback = null) {
    try {
      const raw = localStorage.getItem(PREFIX + key);
      if (raw === null) return fallback;
      return JSON.parse(raw);
    } catch {
      return fallback;
    }
  },
  set(key, value) {
    try {
      localStorage.setItem(PREFIX + key, JSON.stringify(value));
    } catch (err) {
      console.warn('storage.set failed', err);
    }
  },
  remove(key) {
    localStorage.removeItem(PREFIX + key);
  },
  push(key, item) {
    const arr = storage.get(key, []);
    arr.unshift(item);
    storage.set(key, arr);
    return arr;
  },
  updateById(key, id, patch) {
    const arr = storage.get(key, []);
    const next = arr.map((x) => (x.id === id ? { ...x, ...patch } : x));
    storage.set(key, next);
    return next;
  },
};

export const generateReference = (prefix = 'REQ') => {
  const now = new Date();
  const y = now.getFullYear().toString().slice(-2);
  const m = (now.getMonth() + 1).toString().padStart(2, '0');
  const d = now.getDate().toString().padStart(2, '0');
  const rand = Math.random().toString(36).substring(2, 7).toUpperCase();
  return `${prefix}-${y}${m}${d}-${rand}`;
};

export const formatDate = (dateStr) => {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  return d.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
};

export const formatDateTime = (dateStr) => {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  return d.toLocaleString('en-US', { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
};

export const relativeTime = (dateStr) => {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 60) return 'just now';
  if (diff < 3600) return `${Math.floor(diff / 60)} min ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)} hr ago`;
  if (diff < 604800) return `${Math.floor(diff / 86400)} days ago`;
  return formatDate(dateStr);
};
